const addonsBookingNumbersFormatter = (row: App.Order) => {
  return [...(row.addon_items || []), ...(row.experience_items || [])].map((item) => item.booking_number).join(', ');
};

export default addonsBookingNumbersFormatter;
